// TODO(SI): import these out of redux-little-router somehow; they're supposed to correspond to their actions.
export const ROUTER_PUSH = "ROUTER_PUSH";
export const ROUTER_LOCATION_CHANGED = "ROUTER_LOCATION_CHANGED";
